import { EnvironmentConfiguration, FeatureFlags, getEntitledStructures, SecurityModuleName } from '@jms/model';
import { Injectable, signal } from '@angular/core';

@Injectable()
export class ConfigService {

    private static _config: EnvironmentConfiguration;
    public static get environment(): EnvironmentConfiguration {
        this._config = this._config
            ? this._config
            : { ...window['config'] } as any;
        return this._config;
    }

    public static get origin(): string {
        return ConfigService.window().location.origin;
    }

    public static readonly $preventLogin = signal(ConfigService?.environment?.preventLogin ?? false);

    private static window(): any {
        return window;
    }
}

export const propertyManagementEnabled = ConfigService.environment?.plan?.addons[SecurityModuleName.PropertyManagement] ?? false;
export const servicePlanSchedulerEnabled = ConfigService.environment?.featureFlags?.[FeatureFlags.ServicePlanScheduler] ?? false;
export const richTextFontUnitPtEnabled = ConfigService.environment?.featureFlags?.[FeatureFlags.RichTextFontUnitPt] ?? false;
export const workBuddyConnectEnabled = ConfigService.environment?.plan?.addons[SecurityModuleName.WorkBuddyConnect] ?? false;
/** Structures the tenant has bought (WBS-11728); pickers and the New Job dialog offer only these. */
export const entitledStructures = getEntitledStructures(ConfigService.environment?.plan);
export const inlineSideNavEnabled = ConfigService.environment?.featureFlags?.[FeatureFlags.InlineSideNav] ?? false;
export const manageJobProEnabled = ConfigService.environment?.featureFlags?.[FeatureFlags.ManageJobPro] ?? false;
export const isDevelopment = ConfigService?.environment?.domain?.endsWith('.dev');
export const notProduction = !ConfigService?.environment?.domain?.endsWith('.app');
export const aIRefinerEnable = ConfigService.environment?.featureFlags?.[FeatureFlags.AITextboxRefiner] ?? false;
export const speechToText = ConfigService.environment?.featureFlags?.[FeatureFlags.AITextboxVoice] ?? false;
